// extracted by mini-css-extract-plugin
export default {"button":"SRJr1"};